// The page's Player as code outside its React tree reaches it (issue #3708). The Sequencer lives in
// SequencerProvider and React components ask SequencerContext for it; a module with no React behind
// it, such as the Learn audio session, asks here instead. SequencerProvider registers its Sequencer
// while it is mounted. Kept apart from sequencer.tsx so that a caller does not import the Player's
// whole React and data graph just to pause it.

// What a caller outside the Player may do with it
export interface PagePlayer {
  readonly isPlaying: boolean;
  pause(): void;
}

let pagePlayer: PagePlayer | undefined;

// Makes `player` the page's Player; returns the unregister, which leaves a later registration alone
export function registerPagePlayer(player: PagePlayer): () => void {
  pagePlayer = player;
  return () => {
    if (pagePlayer === player) {
      pagePlayer = undefined;
    }
  };
}

// Pauses the song the Player is playing, as its pause button does. Nothing happens when no song is
// playing or no Player is mounted.
export function pausePagePlayer() {
  if (!pagePlayer?.isPlaying) {
    return;
  }
  pagePlayer.pause();
}
